import React from 'react';
import { Text } from 'react-native';
import { Card } from 'react-native-paper';
import { styles } from './ProfileViewStyle';
import { FormCard } from './FormCard';
import { GoalsCheckboxGrid } from './GoalsCheckboxGrid';
import { goalValues } from './formValuesModel';
export const GoalsCard = ({ values, readOnly }) => {
    return (<FormCard>
      <Card.Content>
        <Text style={styles.headerText}>
          Select the goals you want to accomplish:
        </Text>
        <GoalsCheckboxGrid goalValues={goalValues(values)} readOnly={readOnly}/>
      </Card.Content>
    </FormCard>);
};
